import { render, staticRenderFns } from "./logo-container.vue?vue&type=template&id=b1f395a6&"
import script from "./logo-container.vue?vue&type=script&lang=js&"
export * from "./logo-container.vue?vue&type=script&lang=js&"
import style0 from "./logo-container.vue?vue&type=style&index=0&id=b1f395a6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports